import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const ProblemSection = () => {
  const { t } = useLanguage();

  const problems = [
    {
      title: t('problem.recruiterSpam'),
      description: t('problem.recruiterSpamDesc')
    },
    {
      title: t('problem.privacyConcerns'),
      description: t('problem.privacyConcernsDesc')
    },
    {
      title: t('problem.timeWasted'),
      description: t('problem.timeWastedDesc')
    },
    {
      title: t('problem.cvFatigue'),
      description: t('problem.cvFatigueDesc')
    }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-4">
            {t('problem.title')}
          </h2>
          <p className="text-base md:text-lg text-[#6B7280] max-w-2xl mx-auto">
            {t('problem.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {problems?.map((problem, index) => (
            <div 
              key={index}
              className="group relative bg-white rounded-2xl p-6 md:p-8 border border-gray-200 hover:border-[#0025cc]/30 transition-all duration-300 hover:shadow-xl"
            >
              {/* Checkmark Icon */}
              <div className="mb-6">
                <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center">
                  <Icon name="Check" size={20} color="#10B981" />
                </div>
              </div>
              
              {/* Content */}
              <div>
                <h3 className="text-lg md:text-xl font-semibold text-[#111827] mb-3">
                  {problem?.title}
                </h3>
                
                <p className="text-sm md:text-base text-[#6B7280] leading-relaxed">
                  {problem?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;